<h3 id="header" class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
    <div class="ui basic segment" *ngIf="success || error">
      <div class="ui success message" *ngIf="success">
        <i (click)="close()" class="close icon"></i>
        {{success}}
      </div>
      <div class="ui warning message" *ngIf="error">
        <i (click)="close()" class="close icon"></i>
        {{error | json}}
      </div>
    </div>
    <div class="ui form" [formGroup]="workForm">
      <!-- <div class="field" [ngClass]="displayFieldCss('name')">
                <label class="required">Name</label>
                <input type="text" formControlName="name" placeholder="Name">
                <app-field-error-display [displayError]="isFieldValid('name')"
                    errorMsg="Please enter name">
                </app-field-error-display>
            </div> -->
      <div class="field">
        <label class="required">Description</label>
        <textarea rows="2" formControlName="description"></textarea>
      </div>
      <div class="field" [ngClass]="displayFieldCss('workflowType')">
        <label class="required">Workflow Type</label>
        <input type="text" formControlName="workflowType" [readonly]="true" placeholder="Name">
        <!-- <select formControlName="workflowType">
                    <option *ngFor="let type of workFlowTypeList" [value]="type.optionId">{{type.optionName}}</option>
                </select> -->
        <app-field-error-display [displayError]="isFieldValid('workflowType')" errorMsg="Please enter workFlow type">
        </app-field-error-display>
      </div>
    </div>
  </div>
  <div class="actions">
    <button class="ui bg-none color-primary button" (click)="modal.deny(undefined)" appMargin marginR="10px"
      paddingX="15px">Cancel</button>
    <button class="ui  primary button" [ngClass]="{'loading':pending}" [disabled]="!workForm.valid" (click)="save()"
      autofocus>Update</button>
  </div>
</div>
